import * as React from 'react';
import workflowsPlatformAndroidMdm from '../../assets/workflows-platform-android-mdm.svg';

/**
 * TEMPORARY: DoorDash "Hubble Kiosk" MDM branding override.
 *
 * The app is configured on the real `react-native-ota` platform but is used as an
 * MDM-distributed app, so across a few high-value surfaces we present it as "MDM"
 * (label + avatar) instead of "React Native". Keyed on the customer-facing appId
 * (App.appId) so it survives app renames.
 *
 * This is a display-only holdover — no new AppPlatform enum value, no release-logic change.
 * When the real platform type is introduced formally, every surface here works natively off
 * the AppPlatform enum (displayTextForAppPlatform / WorkflowsPlatformIcon / iconForPlatform),
 * so this becomes dead code with no replacement needed.
 *
 * To remove (fully grep-discoverable, bounded to ~16 files):
 *   1. Delete this file, its spec, and the svg asset (workflows-platform-android-mdm.svg).
 *   2. `tsc` then flags every inline call site — revert each `getMdmPlatformOverride(...)?.label ??`
 *      / `mdmOverride` usage back to the plain `displayTextForAppPlatform(...)` / icon.
 *   3. Remove the now-unused optional params `platformLabelOverride` / `platformIconOverride`
 *      (grep them) from the shared helpers/components they were threaded through
 *      (displayStringForDestination, descriptionForSetting, DestinationIcon, DestinationCounter,
 *      GetAppNameWithPlatform, WorkflowStepsSection, DestinationCard, DestinationEditor, TaskListHeader).
 */
export const MDM_ORG_ID = 'doordash';
export const MDM_APP_ID = 'hubble-kiosk-react-native-ota';

export const MDM_TESTING_ORG_ID = 'runway-org';
export const MDM_TESTING_APP_ID = 'mobile-device-management-react-native-ota';

export interface MdmPlatformOverride {
    label: string;
    icon: (size: number) => React.ReactNode;
}

export function getMdmPlatformOverride(
    orgId: string | null | undefined,
    appId: string | null | undefined,
): MdmPlatformOverride | null {
    const matchesTargetApp = orgId === MDM_ORG_ID && appId === MDM_APP_ID;
    const matchesTestingApp = orgId === MDM_TESTING_ORG_ID && appId === MDM_TESTING_APP_ID;

    if (!matchesTargetApp && !matchesTestingApp) {
        return null;
    }

    return {
        label: 'MDM',
        icon: (size) => (
            <img src={workflowsPlatformAndroidMdm} width={size} height={size} style={{ flexShrink: 0 }} alt="" />
        ),
    };
}
